import { useTranslation } from 'react-i18next'

import { Icon } from '@lib/components'

import { ConversationEmptyStateProps } from './types'

type ConversationPlaceholderProps = Pick<ConversationEmptyStateProps, 'mode' | 'isEmpty'>

export const ConversationPlaceholder = ({ mode = 'chat', isEmpty = false }: ConversationPlaceholderProps) => {
  const { t } = useTranslation()

  const messageKey =
    mode === 'chat' ? (isEmpty ? 'Chat.NoConversationsYet' : 'Chat.NoChatSelected') : 'Chat.NoConversationsYet'

  return (
    <>
      <Icon path="no-chat-selected" />
      <h3>{t(messageKey)}</h3>
    </>
  )
}
